/* This file is autogenerated by "pnpm run generateIconComponents" command */
import React from 'react';
import { SVGProps } from 'react';

const ChevronDown: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.0001 13.2929 6.7071 8 5.293 9.4142 12 16.1213l6.7071-6.707L17.293 8z" clipRule="evenodd"/></svg>
);

export default ChevronDown;
